import React from 'react';

import {
    Box,
    Typography,
  } from '@material-ui/core';

export default function ComponentPair({ first, second, ...props }) {
    return (
    <Box display="flex">
      <Typography
        align="left"
        color="primary"
        variant="h6"
        >
        {first}:&nbsp;
        </Typography>
      <Typography
        align="left"
        color={"textSecondary"}
        variant="h6"
        style={props.style}
      >
        {second}
      </Typography>
    </Box>
  );
}
